<template>
  <div class="loading">
    <p>{{ progress }}%</p>
  </div>
</template>

<script>
export default {
  name: 'Loading',
  props: {
    progress: {
      type: Number,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
  .loading {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;

    p {
      @extend %font-bold;

      font-size: 2rem;
      color: $red;
    }
  }
</style>